export default __webpack_public_path__ + "static/cuVIArwv-9eb3c9dbd16d59445f75d7e69e634221.svg";